import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GenericaService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  getRepresentante(): Observable<any> {
    return this.apiService.get(
      `${this.path}/getGenericaRepresentante`,
      new HttpParams(),
      true
    );
  }
}
